import { render, staticRenderFns } from "./PassportDetails.vue?vue&type=template&id=43dda872&"
import script from "./PassportDetails.vue?vue&type=script&lang=js&"
export * from "./PassportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports